import type { ReactNode } from "react";
import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderBase } from "posthog-js/react";

import {
  ANALYTIC_APPS,
  ANALYTIC_SUPER_PROPERTIES,
} from "@animus/observability";

import { ENVIRONMENT } from "../environment";

let initialized = false;

function initPostHog(): void {
  if (initialized || !ENVIRONMENT.POSTHOG) {
    return;
  }

  posthog.init(ENVIRONMENT.POSTHOG.KEY, {
    api_host: ENVIRONMENT.POSTHOG.HOST,
    capture_pageview: false,
    capture_pageleave: true,
    persistence: "localStorage",
  });

  posthog.register({
    [ANALYTIC_SUPER_PROPERTIES.$APP]: ANALYTIC_APPS.WEB,
    [ANALYTIC_SUPER_PROPERTIES.$RELEASE]: ENVIRONMENT.SENTRY_RELEASE,
    [ANALYTIC_SUPER_PROPERTIES.$GIT_SHA]: ENVIRONMENT.GIT_SHA,
  });

  initialized = true;
}

export function PostHogProvider({ children }: { children: ReactNode }) {
  initPostHog();

  if (!ENVIRONMENT.POSTHOG) {
    return <>{children}</>;
  }

  return <PostHogProviderBase client={posthog}>{children}</PostHogProviderBase>;
}

export { posthog };
